import moment from 'moment-timezone';
import find from 'lodash/find';
import head from 'lodash/head';
import get from 'lodash/get';
import isUndefined from 'lodash/isUndefined';
import isObject from 'lodash/isObject';
import { generate } from 'randomstring';

export default {
  data: () => ({
    uniqueIdKvp: {},
  }),
  methods: {
    getUniqueId(key) {
      let uId = this.uniqueIdKvp[key];

      if (!uId) {
        uId = generate();
        this.uniqueIdKvp[key] = uId;
      }

      return uId;
    },
    ariaLabelForGoogleRecaptcha() {
      let recaptchaResponses = document.querySelectorAll('.g-recaptcha-response');

      for (let i = 0; i < recaptchaResponses.length; i++) {
        recaptchaResponses[i].setAttribute('aria-label', 'google recaptcha response');
      }
    },
    currency(value, currencyInfo) {
      let currencySymbol = currencyInfo ? currencyInfo.currency_symbol : '$';

      value = parseFloat(value);

      if (currencyInfo) {
        value = value * currencyInfo.conversion_rate;
      }

      return value ? `${currencySymbol}${value.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}` : `${currencySymbol}0.00`;
    },
    dateFromUTC(value) {
      return moment.utc(value).local().format('M/D/YY h:mm A');
    },
    defaultProduct(products) {
      return find(products, product => product.default_product) || find(products, product => product.product_type === 'MAIN') || head(products);
    },
    get(object, propString) {
      return get(object, propString);
    },
    isUndefined(variable) {
      return isUndefined(variable);
    },
    isObject(variable) {
      return isObject(variable);
    },
    safeNav(object, propString) {
      return get(object, propString);
    },
    kebabCase(string) {
      return string ? string.replace(/\s+/g, "-") : '';
    },
    validateHexOrDefault(value, defaultColor) {
      let substring = value.substr(0, 7);

      return substring.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i) ? substring : defaultColor;
    },
    validateUrl(value) {
      return value.match(/^(http:\/\/|https:\/\/)?(www.)?([a-zA-Z0-9]+).[a-zA-Z0-9]*.[a-z]{3}.?([a-z]+)?$/) ? value : '';
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    scrollHeight() {
      return Math.max(
        document.body.scrollHeight, document.documentElement.scrollHeight,
        document.body.offsetHeight, document.documentElement.offsetHeight,
        document.body.clientHeight, document.documentElement.clientHeight
      );
    },
    scrollTop() {
      return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    },
    scrollLeft() {
      return window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
    },
    windowHeight() {
      return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    },
    windowWidth() {
      return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    },
    elementOffset(element) {
      let rect = element.getBoundingClientRect();

      return {
        top: rect.top,
        left: rect.left,
      }
    },
    _hex(hex) {
      hex = hex.toString(16);
      return (hex.length == 1) ? '0' + hex : hex;
    },
    hexShade(color1, color2, ratio) {
      let r = Math.ceil(parseInt(color1.substring(1, 3), 16) * ratio + parseInt(color2.substring(1, 3), 16) * (1 - ratio)),
        g = Math.ceil(parseInt(color1.substring(3, 5), 16) * ratio + parseInt(color2.substring(3, 5), 16) * (1 - ratio)),
        b = Math.ceil(parseInt(color1.substring(5, 7), 16) * ratio + parseInt(color2.substring(5, 7), 16) * (1 - ratio));

      return `#${this._hex(r)}${this._hex(g)}${this._hex(b)}`;
    },
    isDescendant(parent, child) {
      let node = child.parentNode;

      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }

      return false;
    },
    elementEnteredViewPort(el) {
      let rect = el.getBoundingClientRect();

      return (window.innerHeight || document.documentElement.clientHeight) - rect.top >= 0;
    },
    elementOutOfViewport(el) {
      let bounding = el.getBoundingClientRect(),
        out = {};

      out.top = bounding.top < 0;
      out.left = bounding.left < 0;
      out.bottom = bounding.bottom > (window.innerHeight || document.documentElement.clientHeight);
      out.right = bounding.right > (window.innerWidth || document.documentElement.clientWidth);
      out.any = out.top || out.left || out.bottom || out.right;
      out.all = out.top && out.left && out.bottom && out.right;

      return out;
    },
    updateState(object, property, value) {
      this.$store.commit('updateState', { object, property, value });
    },
  },
};